export default __webpack_public_path__ + "static/cart-e036d10bb298d0de8694ab02783598f6.png";